import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {Video} from '@paperlessio/sdk/api/models';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {BlockStore} from '../block/block.store';
import {Subscription} from 'rxjs';
import {BLOCKS_CONFIG, BlocksConfig} from '../blocks.config';
import {filter, map} from 'rxjs/operators';
import {RouterStore} from '@paperlessio/sdk/util';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoComponent implements OnInit, OnDestroy {
  @Input() block: Video;

  subs = new Subscription();

  url: string; // workaround to prevent flickering on every change in editor
  sanitizedUrl: SafeResourceUrl;
  blockSelected: boolean;

  constructor(
    public sanitizer: DomSanitizer,
    private routerStore: RouterStore,
    private cdr: ChangeDetectorRef,
    private blockStore: BlockStore,
    @Inject(BLOCKS_CONFIG) public blocksConfig: BlocksConfig) {
  }

  ngOnInit() {
    this.subs.add(
      this.blockStore.get(this.block.id, true).pipe(filter(b => !!b)).subscribe((block: Video) => {
        if (this.url !== block?.url) {
          this.block.generateEmbedUrl();
          this.url = block.url;
          this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
          this.cdr.markForCheck();
        }
      })
    );

    this.subs.add(this.routerStore.routeParams
      .pipe(map(params => params?.block))
      .subscribe(blockId => {
        const oldBlockSelectedState = this.blockSelected;
        this.blockSelected = !this.block || this.block?.id === +blockId;
        if (this.blockSelected !== oldBlockSelectedState) {
          this.cdr.markForCheck();
        }
      }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
